import IconClosePanel from '@bimser/icons/16/close-panel';
import IconSave from '@bimser/icons/16/save';
import IconSubMenuArrow from '@bimser/icons/16/sub-menu-arrow';
import * as React from 'react';
import { BCFormulaEditor, findMessage } from '../../..';
import Styles from '../../assets/style.scss';
import { IFormulaEditorModalProps } from '../../entities';

const FormulaEditorModal = (props: IFormulaEditorModalProps) => {
	const [newValue, setNewValue] = React.useState(props.value);

	const onChange = (val: string) => {
		setNewValue(val);
	};

	const onOkClick = () => {
		props.onOkClick(newValue);
	};

	const renderSubTitle = () => (
		<>
			<span
				className="modal-title-text"
				title="Formula Editor"
			>
				Formula Editor
			</span>
			<br />
			<div className={Styles.subTitle}>
				<span>{props.name}</span>
				<span>
					<IconSubMenuArrow
						width="16px"
						height="16px"
					/>
				</span>
				<span>Formula Editor</span>
			</div>
		</>
	);

	const renderHeader = () => (
		<>
			{renderSubTitle()}
			<div className={Styles.headerButtons}>
				<div
					className={Styles.closeButton}
					onClick={props.onCancelClick}
				>
					<IconClosePanel />
				</div>
				<div
					className={Styles.saveButton}
					onClick={onOkClick}
				>
					<IconSave
						width="16px"
						height="16px"
					/>
					<span>{findMessage.get('100620')}</span>
				</div>
			</div>
		</>
	);

	return (
		<>
			<div className="row no-gutters">
				<div className="col-md-12">
					<div className={Styles.modalHeader}>{renderHeader()}</div>
				</div>
			</div>
			<BCFormulaEditor
				onValueChanged={onChange}
				value={newValue}
				fields={props.fields}
			/>
		</>
	);
};
export default FormulaEditorModal;
